import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { FormikProps } from "formik";
import { ReactNode, useCallback, useMemo } from "react";

interface CreateModalProps<T> {
    onClose: () => void;
    open: boolean;
    formik: FormikProps<T>;
    formComponent?: React.ReactNode;
    title?: string;
    submitTitle?: ReactNode;
    disabled?: boolean;
}
export const ManageModal = <T extends unknown>({
    open,
    onClose,
    title,
    formik,
    formComponent,
    submitTitle = "Save",
    disabled,
}: CreateModalProps<T>) => {
    const formikMemo = useMemo(() => formik, [formik]);
    const formComponentMemo = useMemo(() => formComponent, [formComponent]);
    const handleOnClose = useCallback(() => {
        formikMemo.resetForm();
        onClose();
    }, [formikMemo, onClose]);
    return (
        <Dialog open={open}>
            <form onSubmit={formikMemo.handleSubmit}>
                <DialogTitle textAlign="center">{title}</DialogTitle>
                <DialogContent>
                    <Stack
                        sx={{
                            // width: "100%",
                            // minWidth: { xs: "300px", sm: "360px", md: "400px" },
                            width: { xs: "300px", sm: "360px", md: "400px" },
                            gap: "1.5rem",
                        }}
                    >
                        {formComponentMemo}
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: "1.25rem" }}>
                    <LoadingButton loading={formikMemo.isSubmitting} onClick={handleOnClose}>
                        Cancel
                    </LoadingButton>
                    <LoadingButton
                        loading={formikMemo.isSubmitting}
                        disabled={disabled}
                        color="primary"
                        type="submit"
                        variant="contained"
                    >
                        {submitTitle}
                    </LoadingButton>
                </DialogActions>
            </form>
        </Dialog>
    );
};
